'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';
import useNetworkStatus from '@/hooks/useNetworkStatus';

export default function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());
  useNetworkStatus();

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
